import styled from "styled-components";
import { MainInner } from "@/styles/global";
import { FondCardPadding } from "@/styles/typography";

const TextWrapper = styled(MainInner)`
    ${FondCardPadding}
`;

const TextContent = styled.div`
    color: ${({ theme }) => theme.colors.title};
    font-family: "Open Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    max-width: 530px;
    margin: 0 auto;
    margin-top: 30px;

    @media screen and (max-width: 700px) {
        padding: 5%;
    }
`;

const S = {
  TextWrapper,
  TextContent,
};

export default S;
